import { MenubarDesignTokens } from '@primeuix/themes/types/menubar';

export const Menubar: MenubarDesignTokens = {
  item: {
    focusBackground: '{green.50}',
    color: '{surface.700}',
    focusColor: '{green.600}',
    icon: {
      color: '{surface.700}',
      focusColor: '{green.600}',
    },
  },
  colorScheme: {
    dark: {
      root: {
        background: '{surface.100}',
      },
      item: {
        focusBackground: '{green.700}',
        focusColor: '{green.100}',
        icon: {
          focusColor: '{green.100}',
        },
      },
    },
  },
};
